import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=0c57beb8&"
import script from "./Center.vue?vue&type=script&lang=ts&"
export * from "./Center.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Center.vue"
export default component.exports